<template>
  <v-card
    tile
    class="mtfont"
  >
    <v-container class="pt-6">
      <v-toolbar dense flat>
        <v-toolbar-title>Add New Formula</v-toolbar-title>

        <v-spacer></v-spacer>
        <v-btn
          depressed
          text
          class="mb-3 mr-3"
          v-on:click="$router.push({name: 'Admin'})"
        >CANCEL</v-btn>
        <v-btn
          depressed
          color="black"
          style="color: #fecb39;"
          class="mb-3 mr-3"
          v-on:click="saveFormula"
        >SAVE</v-btn>
      </v-toolbar>

      <v-card class="mtfont" outlined>
        <v-card-title>
          <span>COLOR</span>
        </v-card-title>
        <v-card-text>
          <small>Select Existing Color, or Manually Enter Information for New Color</small>
          <v-row>
            <v-col
            cols="12"
            sm="2">
              <v-select
                id="colorSelector"
                :items="colors"
                v-model="color"
                item-text="code"
                item-color="accent"
                color="accent"
                class="mx-2 mt-4"
                outlined
                dense
                label="Existing"
                v-on:change="setColorFields"
              ></v-select>
            </v-col>

            <v-col 
              cols="12"
              sm="2">
              <v-text-field
                label="Code*"
                v-model="colorCode"
                required
              ></v-text-field>
            </v-col>
            <v-col 
              cols="12"
              sm="5">
              <v-text-field
                label="Name*"
                v-model="colorName"
                required
              ></v-text-field>
            </v-col>
            <v-col 
              cols="12"
              sm="2">
              <v-text-field
                label="Hex*"
                v-model="colorHex"
                required
              ></v-text-field>
            </v-col>
            <v-col 
              cols="12"
              sm="1">
              <LighteningBoltIndicater :hexColor="colorHex" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card class="mtfont mt-4" outlined>
        <v-card-title>
          <span >FORMULA</span>
          <v-spacer></v-spacer>
          <span class="gram-total">TOTAL: {{total}}g</span>
        </v-card-title>
        <v-card-text>
          <v-row><v-col style="color:#FECB39">MATERIALS</v-col></v-row>
          <v-row>
            <v-col
              v-for="item in materials"
              :key="item.name"
              cols="12"
              sm="3">
              <v-text-field
                :label="item.name"
                v-model="formula[item.id]"
                required
              ></v-text-field>
            </v-col>
          </v-row>

        </v-card-text>
      </v-card>
    </v-container>
  </v-card>
</template>

<script>
import LighteningBoltIndicater from '@/components/Add/NewLighteningBoltSwatch.vue';

  export default {
    name: 'FormulaTable',
    props: ['item'],
    
    components: {
      LighteningBoltIndicater
    },

    data: () => ({
      colors: [],
      color: '',
      colorCode: '',
      colorName: '',
      colorHex: '',
      materials: [],
      formula: {}
    }),
    computed: {
      total: function () {
        return Object.keys(this.formula).reduce((total, item) => {
          return (total + +this.formula[item])
        }, 0);
      }
    },
    methods: {
      saveFormula() {
        if(!this.colorName || !this.colorCode || !this.colorHex) {
          alert('Missing Color Information!\nEnter missing information and try again.');
          return;
        }
        else if(!Object.keys(this.formula).length || !Object.keys(this.formula).reduce((total, key)=>{return (total + +this.formula[key]);}, 0)) {
          alert('No Materials Entered!\nEnter missing information and try again.');
          return;
        }

        const materials = Object.keys(this.formula).map(material => `{material: "${material}", amount: ${+this.formula[material]}}`);

        const updateString = `{
          color: {
            code: "${this.colorCode}",
            name: "${this.colorName}",
            hex: "${this.colorHex}"
          },
          materials: [${materials}],
          total: ${this.total}
        }`;

        this.$store.dispatch('submitNewFormula', updateString)
          .then(result => {
            if(result.status === 200) result.json();
            else throw new Error('ERROR! Formula Submission Failed with Server Error ' + result.status);
          })
          .then(data => {
            alert('Success! New Formula Saved.');
            this.$router.push({name: 'Admin'});
          })
          .catch(error => {
            console.error('ERROR', error);
            alert(error);
          });
      },
      setColorFields(event) {
        const selectedColor = this.colors.find(color => color.code === event);

        this.colorCode = event;
        this.colorHex = selectedColor.hex;
        this.colorName = selectedColor.name;
      }
    },
    created() {
      this.$store.dispatch('setAllColors')
        .then(() => {
          this.colors = this.$store.getters.getAllColors;
          if(this.item) {
            this.color = this.item;
            this.setColorFields(this.color);
          }
        });

      this.$store.dispatch('getAllMaterials')
        .then(results => results.json())
        .then(data => { this.materials = data.data.materials});
    }
  }
</script>

<style scoped>
.gram-total {
  font-size: 15px;
}
</style>